import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 6.12132 10.1213"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="square"
      d="M1.06066 9.06066L5.06066 5.06066L1.06066 1.06066"
    />
  </svg>
);
export default SvgChevronRight;
